import { render } from "./AssignedToMe.vue?vue&type=template&id=7cf4d06c&scoped=true"
import script from "./AssignedToMe.vue?vue&type=script&lang=js"
export * from "./AssignedToMe.vue?vue&type=script&lang=js"

import "./AssignedToMe.vue?vue&type=style&index=0&id=7cf4d06c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf4d06c"]])

export default __exports__